import React, { useRef, useState } from "react";
import { Card } from "react-bootstrap";
import {
  useAppSelector,
  useAppDispatch,
} from "../../../../redux/hooks/redux-hooks";
import { setProjectCreationComment } from "../../../../redux/actions/ProjectCommentActions";
import {
  Avatar,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";

const BidCreationCommentsSection = () => {
  const [commentText, setCommentText] = useState<string>("");
  const [isDialogOpen, setDialogOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [dialogPosition, setDialogPosition] = useState<{
    top: number;
    left?: number;
  } | null>(null);

  // const projectCreationComment = useAppSelector(
  //   (state) => state.projectComments.project_creation_comment
  // );
  const maxLength = 2000;
  const [remainingLen, setRemainingLen] = useState(maxLength || 0);

  const allUsers = useAppSelector((state) => state.user.all_Users);
  const loggedInUser = useAppSelector((state) => state.user.loggedIn_User);
  const dispatch = useAppDispatch();

  const handleCommentChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    const value = e.currentTarget.value;
    setCommentText(value);
    setRemainingLen(maxLength - value.length);
    if (value.length > 0) {
      const mention = value[value.length - 1].match(/@/);
      if (mention) {
        if (inputRef.current) {
          const inputPosition = inputRef.current.getBoundingClientRect();
          setDialogPosition({
            top: inputPosition.top - 200,
            left: inputPosition.left,
          });
          setDialogOpen(true);
        }
      } else {
        setCommentText(value);
        setDialogOpen(false);
      }
    }

    dispatch(
      setProjectCreationComment({
        projectCommentId: 0,
        projectId: 0,
        creationDate: new Date(),
        commenterName: loggedInUser.fullName,
        commenterUserId: loggedInUser.userId,
        commentText: commentText,
      })
    );
  };

  const handleMemberClick = (member: any) => {
    let memberUserName = `${member.firstName}${member.lastName}`;
    memberUserName = memberUserName.replace(/[" "]/, "");
    setCommentText((prevText) => {
      return `${prevText}${memberUserName} `;
    });
    setDialogOpen(false);
  };

  return (
    <>
      <Card style={{ border: "none" }}>
        <Card.Body>
          <Stack direction="row">
            <Typography component="span" variant="subtitle2">
              Comments
            </Typography>
          </Stack>
          <TextField
            placeholder="Enter your comments"
            multiline
            maxRows={5}
            onChange={handleCommentChange}
            value={commentText}
            variant="standard"
            fullWidth
            inputProps={{ maxLength: maxLength }}
            helperText={
              maxLength ? `Remaining characters ${remainingLen}` : null
            }
            inputRef={inputRef}
          />
          {/* <TextBox
            label="Comments"
            placeholder="Enter your comments"
            multiline
            maxRows={5}
            inputProps={{ maxLength: 2000 }}
            fullWidth
            changeHandler={handleCommentChange}
            value={projectCreationComment.commentText}
            variant="standard"
          /> */}
        </Card.Body>
      </Card>
      <Dialog
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        style={{
          position: "absolute",
          top: dialogPosition?.top,
          left: dialogPosition?.left,
        }}
        hideBackdrop={true}
      >
        <DialogTitle>Members</DialogTitle>
        <List sx={{ pt: 0 }}>
          {allUsers.map((user) => (
            <ListItem key={user?.userId}>
              <ListItemButton onClick={() => handleMemberClick(user)}>
                <ListItemAvatar>
                  <Avatar>
                    <AccountCircle />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={`${user.firstName}${user.lastName}`} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Dialog>
    </>
  );
};

export default BidCreationCommentsSection;
